'use client';

import { useTranslations } from 'next-intl';
import { Box, VStack, token } from '@terra/ui-styled-system';
import { Search01Icon } from '@terra/ui-icons';
import { BodyStrong, MetaDefault } from '../typography';

export function MenuEmptyState() {
  const t = useTranslations('designSystem.menu');

  return (
    <Box px="1" py="6" textAlign="center" w="full" maxW="206px" margin="0 auto">
      <VStack gap="2" alignItems="center">
        <Box opacity={0.5}>
          <Search01Icon size={24} color={token('colors.fg.muted')} />
        </Box>
        <VStack gap="1" alignItems="center">
          <BodyStrong color="fg.default">{t('emptyState.title')}</BodyStrong>
          <MetaDefault color="fg.muted">
            {t('emptyState.description')}
          </MetaDefault>
        </VStack>
      </VStack>
    </Box>
  );
}
